// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MediumCircleFilledSvg from "@ant-design/icons-svg/es/asn/MediumCircleFilled";
import AntdIcon from '../components/AntdIcon';

var MediumCircleFilled = function MediumCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MediumCircleFilledSvg
  }));
};

MediumCircleFilled.displayName = 'MediumCircleFilled';
export default React.forwardRef(MediumCircleFilled);